import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactNode, createContext, useContext } from 'react';

interface ApiContext {
  host: string | undefined;
}

export const ApiContext = createContext<ApiContext>({ host: '' });

export function ApiContextProvider({
  children,
  value,
}: {
  value: ApiContext;
  children: ReactNode;
}) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
    queryCache: new QueryCache({
      onError: (err) => {
        console.error(err);
      },
    }),
  });

  return (
    <ApiContext.Provider value={value}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ApiContext.Provider>
  );
}

export const useApiContext = () => {
  const { host } = useContext(ApiContext);
  return { host: host ?? '' };
};
